import { render } from "./ContactView.vue?vue&type=template&id=18e6b955"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=18e6b955&lang=scss"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__